<template>
  <div>
    <a-card>
      <div class="main-panel" style="height: 800px">
        <div style="text-align: right">
          <a-button style="" type="link" @click="add()">
            添加
          </a-button>
          <a-dropdown trigger="click">
            <a-button type="link">GPS设备号导入导出</a-button>
            <a-menu slot="overlay">
              <a-menu-item icon="el-icon-upload">
                <a-upload
                  action="/api/import-gpsCode"
                  @change="handleSuccess"
                  :before-upload="beforeAvatarUpload"
                  :showUploadList="false">
                  <span>上传文件</span>
                </a-upload>
              </a-menu-item>
              <a-menu-item @click="exportExcel">下载文件
              </a-menu-item>
              <a-menu-item @click="downloadExcel">下载模板
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </div>
        <div class="main-content-wrap">
          <a-row>
            <a-col :span="24">
              <a-table :loading="table.loading"
                       :data-source="table.data"
                       :default-sort="table.sort"
                       :pagination="table.pagination"
                       @change="handleTableChange"
                       ref="table.dataRef">
                <a-table-column align="center" data-index="boxNo" title="箱号" width="">
                </a-table-column>
                <a-table-column align="center" data-index="gpsCode" title="GPS设备编码" width="">
                </a-table-column>
                <a-table-column
                  align="center"
                  :sorter="true"
                  key="createAt"
                  data-index="createAt" title="创建时间" width="120">
                </a-table-column>
                <a-table-column
                  align="center"
                  :sorter="true"
                  key="updatedAt"
                  data-index="updatedAt" title="更新时间" width="120">
                </a-table-column>
                <a-table-column
                  align="center"
                  :sorter="true"
                  key="date"
                  data-index="date" title="操作" width="120">
                  <template slot-scope="text, record">
                    <a-button type="link" @click="edit(record)">编辑
                    </a-button>
                    <a-button type="link" @click="del(record)">删除
                    </a-button>
                  </template>
                </a-table-column>
              </a-table>
            </a-col>

          </a-row>
        </div>
      </div>
    </a-card>
    <a-modal v-model="form.visible" width="600px" @cancel="onFormCancel" @ok="onFormSave" :destroy-on-close="true">
      <gpsNo-edit :get-list="getList" :gps-id="form.data.gpsId" ref="gpsForm"></gpsNo-edit>
    </a-modal>
  </div>
</template>

<script>
import {getGpsCodeList, delGpsCode} from '../../../api/gpsCode';
import GpsNoEdit from './GpsNoEdit';
import {getTime} from '../../../utils/dateUtil';


async function getList() {
  const currentPage = this.table.pagination.current - 1;
  const result = await getGpsCodeList(currentPage, this.table.pagination.pageSize);
  if (result.code === 1200) {
    this.$set(this.table, 'data', result.data.list);
    this.$set(this.table.pagination, 'total', result.data.totalCount);
    // this.table.pagination.total = result.data.totalCount;
  }
}

async function onFormSave() {
  await this.$refs.gpsForm.save();
  this.form.visible = false;
  this.form.data = {};
  // this.getList();
}


function onFormCancel() {
  this.form.visible = false;
  // this.getList();
  this.form.data = {};
}

function edit(record) {
  this.form.data.gpsId = record.id;
  this.form.visible = true;
}

function add() {
  this.form.data.gpsId = '';
  this.form.visible = true;
}

function del(record) {
  let that = this;
  this.$confirm({
    title: '是否删除这条数据?',
    content: '',
    okType: 'danger',
    async onOk() {
      const result = await delGpsCode(record.id);
      if (result.code === 1200) {
        that.$message.success('删除成功');
        that.form.data = {};
        await that.getList();
      }
    },
    //   this.onCancel()
    onCancel() {
    },
    class:
      'test',
  });
}

/**
 * 文件上传之前的回调函数
 */
function beforeAvatarUpload(file) {
  const index = file.name.lastIndexOf('.');
  const fileName = file.name.substring(index + 1);
  if (fileName !== 'xls' && fileName !== 'xlsx') {
    let that = this;
    this.$confirm({
      title: '上传文件必须为 .xls 或 .xlsx 格式 ?',
      content: '',
      okType: 'warning',
      onOk() {
        that.form.dialogVisibleWorker = false;
      },
      //   this.onCancel()
      onCancel() {
        that.form.dialogVisibleWorker = false;
      },
      class:
        'test',
    });
    // this.$confirm('上传文件必须为 .xls 或 .xlsx 格式 ', '提示', {
    //   confirmButtonText: '确定',
    //   cancelButtonText: '取消',
    //   type: 'warning',
    // }).catch(() => {
    //   //                关闭批量上传弹窗
    //   this.form.dialogVisibleWorker = false;
    // });
    return false;
  }
}

function handleSuccess(res) {
  let that = this;
  // setTimeout(() => {
  if(this.uploadTrue){
    if (res.file.response && res.file.response.code === 1200) {
      that.$message.success('上传成功');
      this.getList();
    }
  } else {
    this.uploadTrue = !this.uploadTrue
  }


  // }, 1000)
  // if (res.code === 1200) {
  //   const h = this.$createElement;
  //   const msg = [];
  //   // eslint-disable-next-line guard-for-in,no-restricted-syntax
  //   for (const key in res.data.map) {
  //     msg.push(h('p', key));
  //   }
  //   if (msg.length > 0) {
  //     let that = this;
  //     this.$confirm({
  //       title: h('div', msg),
  //       content: '',
  //       okType: 'danger',
  //       onOk() {
  //       },
  //       //   this.onCancel()
  //       onCancel() {
  //       },
  //       class:
  //         'test',
  //     });
  //     // this.$confirm(h('div', msg), '提示', {
  //     //   type: 'warning',
  //     //   confirmButtonText: '确认',
  //     //   cancelButtonText: '取消',
  //     // });
  //   } else {
  //     this.$message.success('上传成功')
  //     // this.$message({
  //     //   message: '上传成功',
  //     //   type: 'success',
  //     // });
  //   }
  //   this.getList();
  // }
}

function exportExcel() {
  require.ensure([], () => {
    const { export_json_to_excel } = require('../../../utils/Export2Excel');
    const tHeader = ['箱号', '设备编码'];
    // 上面设置Excel的表格第一行的标题
    const filterVal = ['boxNo', 'gpsCode'];
    // 上面的index、nickName、name是tableData里对象的属性
    const list = this.excelData; // 把data里的tableData存到list
    const data = this.formatJson(filterVal, list);
    export_json_to_excel(tHeader, data, `GPS设备号${ getTime() }`);
  });
}

function formatJson(filterVal, jsonData) {
  return jsonData.map(v => filterVal.map(j => v[j]));
}

async function downloadExcel() {
  let that = this;
  this.$confirm({
    title: '是否下载GPS设备号导入模板.xlsx?',
    content: '',
    onOk() {
      window.location.href = '/api/signForImg/GPS设备号导入模板.xlsx';
    },
    onCancel() {
    },
    class:
      'test',
  });
  // this.$confirm('是否下载商务人员导入模板.xlsx？', '提示', {
  //   type: 'warning',
  //   confirmButtonText: '确认',
  //   cancelButtonText: '取消',
  // }).then(async () => {
  //   window.location.href = '/api/signForImg/商务人员导入模板.xlsx';
  // });
}

function handleTableChange(pagination, filters, sorter) {
  this.table.pagination.current = pagination.current;
  this.table.pagination.pageSize = pagination.pageSize;
  this.table.sort = {
    prop: sorter.field,
    order: sorter.order,
  };
  this.getList();
}

export default {
  components: {
    GpsNoEdit,
  },
  methods: {
    getList,
    onFormSave,
    onFormCancel,
    edit,
    add,
    del,
    beforeAvatarUpload,
    handleSuccess,
    exportExcel,
    formatJson,
    downloadExcel,
    handleTableChange,
  },
  data() {
    return {
      // uploadTrue: true,
      excelData: [],
      table: {
        loading: false,
        data: [],
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '40', '50'],
          showTotal: (total, range) => `${ range[0] }-${ range[1] } of ${ total } items`,
        },
      },
      form: {
        visible: false,
        data: {
          gpsId: '',
        },
      },
    };
  },
  async created() {
    this.getList();
    const result = await getGpsCodeList(0, 9999);
    this.excelData = result.data.list;
  },
};
</script>
